module.exports = __webpack_public_path__ + "img/public/SiteIcons/adminPlusIcon.svg?3790d0ca";